import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { reloadOnceForStaleChunk } from './utils/staleChunkReload';
// Brand font: Inter, self-hosted (bundled by Vite, served same-origin) so the
// strict CSP needs no third-party font hosts (security review 2026-07-15, P0-2).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import './styles/theme.css';
import './index.css';

// After a deploy, the hashed page chunks an open tab references no longer
// exist on the server; Vite signals the failed dynamic import through this
// event. Reload to pick up the new build instead of surfacing the error
// (one-shot guarded — see utils/staleChunkReload).
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForStaleChunk()) event.preventDefault();
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Root element with id "root" not found. Check that index.html has <div id="root">.',
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
